import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  flag: {
    width: '26px !important',
    height: '18px !important',
  },
}))

export default styles
